import React from "react";
import { Dialog } from "@/components/toolkit/Dialog";
import { Clickable } from "@/components/toolkit/Clickable";
import { t } from "@/i18n";
import "./s.confirm_dialog.css";

// A yes/no confirmation built on Dialog: a message plus Cancel and a
// confirm button (red when `danger`). Render it conditionally like Dialog.
export function ConfirmDialog(props: {
    title: string;
    message: React.ReactNode;
    confirmLabel: string;
    cancelLabel?: string;
    danger?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}) {
    return (
        <Dialog title={props.title} onClose={props.onCancel}>
            <p className="confirm_dialog__message">{props.message}</p>
            <div className="confirm_dialog__actions">
                <Clickable onClick={props.onCancel}>
                    <button className="confirm_dialog__btn confirm_dialog__btn--cancel">
                        {props.cancelLabel ?? t("settings_cancel")}
                    </button>
                </Clickable>
                <Clickable onClick={props.onConfirm}>
                    <button className={"confirm_dialog__btn " + (props.danger ? "confirm_dialog__btn--danger" : "confirm_dialog__btn--confirm")}>
                        {props.confirmLabel}
                    </button>
                </Clickable>
            </div>
        </Dialog>
    );
}
